var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadMultimedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2777_78664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6668 26.6667L20.0002 20L13.3335 26.6667",
    stroke: "#545454",
    strokeWidth: 3.33334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 20V35",
    stroke: "#545454",
    strokeWidth: 3.33334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9834 30.6501C35.609 29.7639 36.8932 28.3616 37.6332 26.6645C38.3733 24.9674 38.5271 23.0721 38.0704 21.2779C37.6138 19.4837 36.5726 17.8926 35.1112 16.7558C33.6499 15.619 31.8515 15.0013 30.0001 15.0001H27.9001C27.3956 13.0488 26.4554 11.2373 25.15 9.70172C23.8446 8.16614 22.2082 6.94647 20.3636 6.1344C18.519 5.32233 16.5143 4.93899 14.5003 5.01319C12.4862 5.0874 10.5152 5.61722 8.73536 6.56283C6.95554 7.50844 5.41325 8.84523 4.22443 10.4727C3.03561 12.1002 2.23121 13.976 1.87169 15.9591C1.51217 17.9422 1.6069 19.981 2.14875 21.9222C2.69059 23.8634 3.66546 25.6565 5.00006 27.1667",
    stroke: "#545454",
    strokeWidth: 3.33334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6668 26.6667L20.0002 20L13.3335 26.6667",
    stroke: "#545454",
    strokeWidth: 3.33334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2777_78664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadMultimedia);
export default __webpack_public_path__ + "static/media/icon_upload_multimedia.c71255005053bd3d9f610edacafa734b.svg";
export { ForwardRef as ReactComponent };